import React from "react";

/**
 * Bolha de chat simples usada para ilustrar exemplos de conversa no
 * Guia das automacoes da IA.
 *
 * Props:
 * - side: "client" (cinza, esquerda) | "ai" (azul, direita)
 * - text: conteudo da mensagem (pode ser vazio quando so houver efeito)
 * - effect: badge opcional renderizado abaixo da bolha indicando o que
 *   acontece internamente no sistema (ex: "🔒 Ticket fechado")
 */
const ChatBubble = function (props) {
  var side = props.side || "client";
  var text = props.text || "";
  var effect = props.effect || "";
  var isAi = side === "ai";

  var bubbleStyle = {
    maxWidth: "78%",
    padding: text ? "8px 12px" : 0,
    borderRadius: 12,
    fontSize: 12,
    lineHeight: 1.45,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    background: isAi ? "rgba(91, 124, 255, 0.18)" : "rgba(255, 255, 255, 0.06)",
    border: isAi
      ? "1px solid rgba(91, 124, 255, 0.30)"
      : "1px solid rgba(255, 255, 255, 0.08)",
    color: "rgba(255, 255, 255, 0.88)",
    borderBottomRightRadius: isAi ? 4 : 12,
    borderBottomLeftRadius: isAi ? 12 : 4
  };

  var rowStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: isAi ? "flex-end" : "flex-start",
    marginBottom: 8
  };

  var effectStyle = {
    marginTop: 4,
    padding: "4px 8px",
    borderRadius: 6,
    fontSize: 10,
    color: "rgba(255, 220, 130, 0.95)",
    background: "rgba(245, 158, 11, 0.08)",
    border: "1px solid rgba(245, 158, 11, 0.22)",
    fontStyle: "italic",
    maxWidth: "78%"
  };

  return (
    <div style={rowStyle}>
      {text ? <div style={bubbleStyle}>{text}</div> : null}
      {effect ? <div style={effectStyle}>{effect}</div> : null}
    </div>
  );
};

export default ChatBubble;
